import Dispatcher from "Dispatcher";

const safeDispatch = (payload, isStillNeeded) => {
    if (Dispatcher.isDispatching()) {
        console.warn("deferred dispatch of " + payload.type);
        // eslint-disable-next-line no-settimeout
        setTimeout(() => {
            if (isStillNeeded == null || isStillNeeded()) {
                Dispatcher.dispatch(payload);
            }
        });
    } else {
        Dispatcher.dispatch(payload);
    }
};

export default safeDispatch;



// WEBPACK FOOTER //
// ./app/data/util/safeDispatch.js